import { HubConnection, LogLevel } from "@microsoft/signalr";
import { HubConnectionBuilder } from "@microsoft/signalr/dist/esm/HubConnectionBuilder";
import { makeAutoObservable, runInAction } from "mobx";
import { ChatComment } from "../models/ChatComment";
import { store } from "./store";

export default class CommentSrore {
    chatCommentArray: ChatComment[] = [];
    hubConnection: HubConnection | null = null;

    constructor() {
        makeAutoObservable(this);
    }

    createHubConnection = (activityId: string) => {
        //const baseURL = 'http://localhost:5000/chat';
        const baseURL = process.env.REACT_APP_CHAT_URL; //.
        const url = `${baseURL}?activityId=${activityId}`;

        if (store.activityStore.selectedActivity) {

            this.hubConnection = new HubConnectionBuilder()
                .withUrl(url, {
                    accessTokenFactory: () => store.userStore.user?.token!
                })
                .withAutomaticReconnect()
                .configureLogging(LogLevel.Information)
                .build();

            this.hubConnection.start().catch(error => console.log('Error establishing the connection!: ', error));

            this.hubConnection.on('LoadComments', (chatCommentArray: ChatComment[]) => {
                runInAction(() => {  //. becouse we updating the observable in the store, we need to use runInAction
                    chatCommentArray.forEach(comment => {
                        //comment.createdDate = new Date(comment.createdDate + 'Z'); //'nn error
                        comment.createdDate = new Date(comment.createdDate);
                    });

                    this.chatCommentArray = chatCommentArray;
                }); 
            });

            this.hubConnection.on('ReceiveComment', (chatComment: ChatComment) => {
                runInAction(() => {
                    chatComment.createdDate = new Date(chatComment.createdDate);
                    //this.chatCommentArray.push(chatComment);
                    this.chatCommentArray.unshift(chatComment); //'n
                });
            });
        }
    }

    stopHubConnection = () => {
        this.hubConnection?.stop().catch(error => console.log('Error stopping connection!: ', error));
    }

    clearComments = () => {
        this.chatCommentArray = [];
        this.stopHubConnection();
    }

    addComment = async (values: any) => {
        values.activityId = store.activityStore.selectedActivity?.id;
           
        try {
            await this.hubConnection?.invoke('SendComment', values);
        } catch(error) {
            console.log(error);
        }
    }

}